export class ErrorPageError extends Error {
  public constructor(error: Error) {
    super(error.message)

    this.cause = error
    this.name = 'ErrorPageError'
    this.stack = error.stack
  }
}
